/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { accountPages } from '@/pages/accountPages'
import { albumPages } from '@/pages/albumPages'
import { artistPages } from '@/pages/artistPages'
import { audiobookPages } from '@/pages/audiobookPages'
import { browsePages } from '@/pages/browsePages'
import { desktopLibraryPages } from '@/pages/desktopLibraryPages'
import { homePages } from '@/pages/homePages'
import { libraryPages } from '@/pages/libraryPages'
import { livePages } from '@/pages/livePages'
import { merchPages } from '@/pages/merchPages'
import { nowPlayingPages } from '@/pages/nowPlayingPages'
import { playlistPages } from '@/pages/playlistPages'
import { podcastPages } from '@/pages/podcastPages'
import { profilePages } from '@/pages/profilePages'
import { searchPages } from '@/pages/searchPages'
import { stationPages } from '@/pages/stationPages'
import { trackPages } from '@/pages/trackPages'
import { videoPages } from '@/pages/videoPages'

/** Every module a route loads, one `import()` each, keyed by the module's name. */
export const ALL_PAGES = {
    ...accountPages,
    ...albumPages,
    ...artistPages,
    ...audiobookPages,
    ...browsePages,
    ...desktopLibraryPages,
    ...homePages,
    ...libraryPages,
    ...livePages,
    ...merchPages,
    ...nowPlayingPages,
    ...playlistPages,
    ...podcastPages,
    ...profilePages,
    ...searchPages,
    ...stationPages,
    ...trackPages,
    ...videoPages,
}

export type Pages = typeof ALL_PAGES
